// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MorePosts__posts":"ox_a bhb_qh bhb_qb bhb_wl"};